import styled from '@emotion/styled'
import React from 'react';

type WithChildren<T = {}> = 
T & { children?: React.ReactNode };

const Content = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

export function CenteredHorizontalFlex({ children }: WithChildren){
  return (
        <Content>
            {children}
        </Content>
  );
}
